export default {
  CREATE: 'CREATE_UPLOAD',
  UPDATE: 'UPDATE_UPLOAD',
  DELETE: 'DELETE_UPLOAD',
};
